(function($) {

    $('.image-text-slider').each(function(index, el) {
        const autoplay = $(this).find('.swiper-container').data('autoplay');

        const buttonPrev = $(this).find('.arrow-navigation .button-prev');
        const buttonNext = $(this).find('.arrow-navigation .button-next');

        const swiperOptions = {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: autoplay,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.button-next',
                prevEl: '.button-prev',
            },
        }

        if (autoplay) {
            swiperOptions.autoplay = {delay: 5000};
        }

        const slider = new Swiper($(this).find('.swiper-container')[0], swiperOptions)
    });

})( jQuery );